// src/service/apiRequest.ts
import apiClient from './apiClient';
import { showError, showSuccess } from '../components/errorHandler';

interface ApiRequestParams {
  method?: 'get' | 'post' | 'put' | 'delete';
  url: string;
  data?: Record<string, any> | FormData | null;
  params?: Record<string, any> | null;
  headers?: Record<string, string>;
  config?: Record<string, any>;
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
  silent?: boolean;
}

interface UserData {
  user_organization_id: string;
  user_id: string;
}

export const apiRequest = async <T = any>({
  method = 'get',
  url,
  data,
  params,
  headers = {},
  config = {},
  silent = false,
}: ApiRequestParams): Promise<T> => {
  try {
    const axiosConfig: any = {
      method,
      url,
      params,
      headers,
      ...config,
    };

    const methodWithBody = ['post', 'put', 'patch'];
    if (data !== undefined && data !== null && methodWithBody.includes(method.toLowerCase())) {
      axiosConfig.data = data;
    }

    const response = await apiClient(axiosConfig);

    if (response.status >= 200 && response.status < 300) {
      return response.data as T;
    } else {
      const errorMessage = response.data?.message || 'An error occurred!';
      // showError(errorMessage);
      throw new Error(errorMessage);
    }
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'An unexpected error occurred!';
    console.error('API Error:', error.response);
    if (!silent) {
      showError(errorMessage);
    }
    throw error;
  }
};

